import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Spauth } from './hooks/useSpauth';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Montserrat',
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Spauth appId="promo-viewer">
        <App />
      </Spauth>
    </ThemeProvider>
  </React.StrictMode>
);
